var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title"}],staticClass:"ArticleDetail text-left",attrs:{"data-title":"详情"}},[_c('ArticleDetailCom',{attrs:{"fetchDetailApi":_vm.getArticleDetail,"detailId":_vm.$route.params.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }